module.exports = __webpack_public_path__ + "img/shopify003.d21ec27e.jpg";